import governorJsonTestnet from "contracts/testnet/governor.json";
import coinNftJsonTestnet from "contracts/testnet/coinNFT.json";

const getChainType = (chainId) => {
  const CHAIN_MAP = {
    "0x89": "Mainnet",
    "0x13881": "Testnet",
  };
  return CHAIN_MAP[chainId];
};

const getGovernorContractJson = (chainType) => {
  if (chainType === "Testnet") {
    return {
      address: governorJsonTestnet.address,
      abi: governorJsonTestnet.abi,
    };
  }
};

const getCoinNftJson = (chainType) => {
  if (chainType === "Testnet") {
    return {
      address: coinNftJsonTestnet.address,
      abi: coinNftJsonTestnet.abi,
    };
  }
};

export { getGovernorContractJson, getCoinNftJson, getChainType };
